import script from "./SubjectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubjectPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__